import angular from 'angular';

angular.module('neurotecAbisWebClientApp').filter('far', ['FARConverterService', function (FARConverterService) {
	return function (input, isDisabled = false) {
		if (isDisabled) return input;
		const far = FARConverterService.toFar(input);
		return far;
	};
}]);
